<template>
  <!-- 外汇储备 -->
  <div class="table_container">
    <table>
      <tbody align="center">
        <tr>
          <th width="175px">周期</th>
          <th colspan="4">{{ `${Number(queryParams.years) - 3}年` }}</th>
          <th colspan="4">{{ `${Number(queryParams.years) - 2}年` }}</th>
          <th colspan="4">{{ `${Number(queryParams.years) - 1}年` }}</th>
        </tr>
        <tr>
          <th>季度</th>
          <th v-for="(item, index) in Qlist" :key="index">
            {{ item.quarter }}
          </th>
        </tr>
        <tr>
          <th>储备金额(亿美金)</th>
          <th v-for="(item, index) in Qlist" :key="index">
            {{ beforeThreeMoney[item.reserveAmount] }}
          </th>
        </tr>
        <tr>
          <th>进口覆盖天数</th>
          <th v-for="(item, index) in Qlist" :key="index">
            {{ beforeThreeDay[item.importCoverDays] }}
          </th>
        </tr>
        <tr>
          <th></th>
          <th colspan="12">{{ `${queryParams.years}年` }}</th>
        </tr>
        <tr>
          <th>月度</th>
          <th v-for="(item, index) in monthList" :key="index">
            {{ item.month }}
          </th>
        </tr>
        <tr v-if="Number(queryParams.years) >= 2025">
          <th>储备金额(亿美金)</th>
          <td
            v-for="(item, index) in monthList"
            :key="index"
            @click="handleColumn(item.reserveAmount)"
          >
            <el-input-number
              v-if="editField === item.reserveAmount"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.searchYearMoney[item.reserveAmount]"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.searchYearMoney[item.reserveAmount] }}
            </span>
          </td>
        </tr>
        <tr v-else>
          <th>储备金额(亿美金)</th>
          <th v-for="(item, index) in monthList" :key="index">
            {{ form.searchYearMoney[item.reserveAmount] }}
          </th>
        </tr>
        <tr v-if="Number(queryParams.years) >= 2025">
          <th>进口覆盖天数</th>
          <td
            v-for="(item, index) in monthList"
            :key="index"
            @click="handleColumn(item.importCoverDays)"
          >
            <el-input-number
              v-if="editField === item.importCoverDays"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="1"
              v-model="form.searchYearDay[item.importCoverDays]"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.searchYearDay[item.importCoverDays] }}
            </span>
          </td>
        </tr>
        <tr v-else>
          <th>进口覆盖天数</th>
          <th v-for="(item, index) in monthList" :key="index">
            {{ form.searchYearDay[item.importCoverDays] }}
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { addOrUpdateForeignExchangeReserveApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      beforeThreeMoney: {},
      beforeThreeDay: {},
      form: this.getForm(),
      editField: "", // 编辑单元格
      Qlist: [
        {
          quarter: "Q1",
          reserveAmount: "firstQ1Money",
          importCoverDays: "firstQ1Day"
        },
        {
          quarter: "Q2",
          reserveAmount: "firstQ2Money",
          importCoverDays: "firstQ2Day"
        },
        {
          quarter: "Q3",
          reserveAmount: "firstQ3Money",
          importCoverDays: "firstQ3Day"
        },
        {
          quarter: "Q4",
          reserveAmount: "firstQ4Money",
          importCoverDays: "firstQ4Day"
        },
        {
          quarter: "Q1",
          reserveAmount: "secondQ1Money",
          importCoverDays: "secondQ1Day"
        },
        {
          quarter: "Q2",
          reserveAmount: "secondQ2Money",
          importCoverDays: "secondQ2Day"
        },
        {
          quarter: "Q3",
          reserveAmount: "secondQ3Money",
          importCoverDays: "secondQ3Day"
        },
        {
          quarter: "Q4",
          reserveAmount: "secondQ4Money",
          importCoverDays: "secondQ4Day"
        },
        {
          quarter: "Q1",
          reserveAmount: "thirdQ1Money",
          importCoverDays: "thirdQ1Day"
        },
        {
          quarter: "Q2",
          reserveAmount: "thirdQ2Money",
          importCoverDays: "thirdQ2Day"
        },
        {
          quarter: "Q3",
          reserveAmount: "thirdQ3Money",
          importCoverDays: "thirdQ3Day"
        },
        {
          quarter: "Q4",
          reserveAmount: "thirdQ4Money",
          importCoverDays: "thirdQ4Day"
        }
      ], // 季度
      monthList: [
        {
          month: "1月",
          reserveAmount: "oneMoney",
          importCoverDays: "oneDay"
        },
        {
          month: "2月",
          reserveAmount: "twoMoney",
          importCoverDays: "twoDay"
        },
        {
          month: "3月",
          reserveAmount: "threeMoney",
          importCoverDays: "threeDay"
        },
        {
          month: "4月",
          reserveAmount: "fourMoney",
          importCoverDays: "fourDay"
        },
        {
          month: "5月",
          reserveAmount: "fiveMoney",
          importCoverDays: "fiveDay"
        },
        {
          month: "6月",
          reserveAmount: "sixMoney",
          importCoverDays: "sixDay"
        },
        {
          month: "7月",
          reserveAmount: "sevenMoney",
          importCoverDays: "sevenDay"
        },
        {
          month: "8月",
          reserveAmount: "eightMoney",
          importCoverDays: "eightDay"
        },
        {
          month: "9月",
          reserveAmount: "nineMoney",
          importCoverDays: "nineDay"
        },
        {
          month: "10月",
          reserveAmount: "tenMoney",
          importCoverDays: "tenDay"
        },
        {
          month: "11月",
          reserveAmount: "elevenMoney",
          importCoverDays: "elevenDay"
        },
        {
          month: "12月",
          reserveAmount: "twelveMoney",
          importCoverDays: "twelveDay"
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.queryParams = { ...queryParams };
      this.beforeThreeMoney = data.beforeThreeMoney || {};
      this.beforeThreeDay = data.beforeThreeDay || {};
      this.form = this.getForm(
        data.searchYearMoney || {},
        data.searchYearDay || {}
      );
    },
    // 获取表单数据
    getForm(searchYearMoney = {}, searchYearDay = {}) {
      return {
        searchYearMoney: {
          id: searchYearMoney.id || "",
          oneMoney: searchYearMoney.oneMoney ?? undefined,
          twoMoney: searchYearMoney.twoMoney ?? undefined,
          threeMoney: searchYearMoney.threeMoney ?? undefined,
          fourMoney: searchYearMoney.fourMoney ?? undefined,
          fiveMoney: searchYearMoney.fiveMoney ?? undefined,
          sixMoney: searchYearMoney.sixMoney ?? undefined,
          sevenMoney: searchYearMoney.sevenMoney ?? undefined,
          eightMoney: searchYearMoney.eightMoney ?? undefined,
          nineMoney: searchYearMoney.nineMoney ?? undefined,
          tenMoney: searchYearMoney.tenMoney ?? undefined,
          elevenMoney: searchYearMoney.elevenMoney ?? undefined,
          twelveMoney: searchYearMoney.twelveMoney ?? undefined
        },
        searchYearDay: {
          id: searchYearDay.id || "",
          oneDay: searchYearDay.oneDay ?? undefined,
          twoDay: searchYearDay.twoDay ?? undefined,
          threeDay: searchYearDay.threeDay ?? undefined,
          fourDay: searchYearDay.fourDay ?? undefined,
          fiveDay: searchYearDay.fiveDay ?? undefined,
          sixDay: searchYearDay.sixDay ?? undefined,
          sevenDay: searchYearDay.sevenDay ?? undefined,
          eightDay: searchYearDay.eightDay ?? undefined,
          nineDay: searchYearDay.nineDay ?? undefined,
          tenDay: searchYearDay.tenDay ?? undefined,
          elevenDay: searchYearDay.elevenDay ?? undefined,
          twelveDay: searchYearDay.twelveDay ?? undefined
        }
      };
    },
    // 点击单元格编辑
    handleColumn(field) {
      this.editField = field;
      this.$nextTick(() => {
        if (Array.isArray(this.$refs.focusRef)) {
          this.$refs.focusRef[0]?.focus();
        } else {
          this.$refs.focusRef?.focus();
        }
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
    },
    // 保存
    async handleSave(callBack) {
      try {
        let submitData = JSON.parse(JSON.stringify(this.form));
        submitData.searchYearMoney = {
          ...this.queryParams,
          ...submitData.searchYearMoney
        };
        submitData.searchYearDay = {
          ...this.queryParams,
          ...submitData.searchYearDay
        };
        const res = await addOrUpdateForeignExchangeReserveApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.form.searchYearMoney.id = res.data.searchYearMoney.id;
          this.form.searchYearDay.id = res.data.searchYearDay.id;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 0 18px 0 50px;

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 4px 12px;
    height: 40px;
    font-size: 14px;
    word-break: break-all;
  }
  th {
    background-color: #f2f2f2;
  }
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
